<div class="d-flex align-items-center gap-1">
	@if (!isSidebar) {
		<button type="button" [disabled]="isAddNewDisabled()" (click)="onAddNewClick()" vbBtnWhite>
			{{ 'NewBanner' | translate }}
		</button>
	}
	@if (!isSidebar && banners?.length >= MAX_BANNERS) {
		<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'MaximumAmountReached' | translate">
		</vb-ui-tooltip>
	}
</div>

<div ngForm="form" class="margin-top-20">
	@for (link of banners; track $index; let index = $index) {
		<banner-entry [name]="'link' + index" [(ngModel)]="banners[index]" [showPreviewBtn]="true" [showEditDeleteBtns]="!isAddingNewBanner && !isSidebar" (editEntry)="onEditEntry(index)" (deleteEntry)="onDeleteEntry(index)">
		</banner-entry>
	}

	@if (isAddingNewBanner) {
		<banner-add-form class="display-block" [name]="'newBanner'" [(ngModel)]="newBanner" [isDuplicateName]="isDuplicateNameForForm" (addEntry)="onSaveEntry($event)" (cancel)="onCancelAddEntry()">
		</banner-add-form>
	}
</div>
